import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useVisualIdentityReducer = () =>
  useSelector((state: ApplicationState) => state.visualIdentity);
